import axios from 'axios'
import { ElMessage, ElNotification } from 'element-plus'


let baseURL = window.localStorage.getItem('ip')
export function request(config) {
    const instance = axios.create({
        //baseURL: '/api',
       // baseURL: 'https://te.ali.yuancong1999.top',
        //baseURL: 'https://mz.yuancong1999.top',
        baseURL: baseURL,
        // baseURL: 'https://mz.yuancong1999.top',
        TIMEOUT: 5000,
        headers: {
            'accessToken': window.localStorage.getItem('accessToken'),
        }
    })

    
    // 响应拦截器
    instance.interceptors.response.use(res => {
        show_msg(res)
        if (res.data.message == "未登录") {
            
        }


        return res.data
    })
    return instance(config)
}



// 统一展示信息
function show_msg(res) {
    let { method } = res.config
    let { msg, code, title, duration } = res.data
    if (msg) {
        if (code == 1000) return ElNotification({ message: msg, title, duration, type: 'success' })
        if (code == 0 || code == null) return ElMessage({ message: msg, type: 'success' })
        if (code != 0) ElMessage({ message: msg, type: 'danger' })
    }
}